//*************************DO NOT MODIFY*************************************
//
//THESE FILES ARE AUTOGENERATED AND ANY MODIFICATIONS MADE HERE WILL BE LOST
//
//*************************DO NOT MODIFY*************************************

import { MainElement } from './MainElement';
import { IBaseTemplateModel, BaseTemplateModel } from './BaseTemplateModel';

export interface IUnitTemplateDataViewModel extends IBaseTemplateModel {
    id?: number;
    disciplineId?: number;
    unitTypeId?: number;
    maximumBoardCapacity?: number | null;
    version?: string | null;
    mainElements?: MainElement[];
    maximumReaderCapacity?: number | null;
}

export class UnitTemplateDataViewModel extends BaseTemplateModel implements IUnitTemplateDataViewModel {
    public id: number;
    public disciplineId: number;
    public unitTypeId: number;
    public maximumBoardCapacity: number | null;
    public version: string | null;
    public mainElements: MainElement[];
    public isLocked: boolean;
    public maximumReaderCapacity?: number | null;
}
